export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/woocommerce.4611da9.svg";